<template>
    <div class="template">
        <div class="tempRight">
            <div class="tempTitle">
                <div class="left">离线签署</div>
            </div>
            <div class="temp_for">
                <div class="offline">
                    <div class="offline_card">
                        <div>
                            <span class="offline_what">什么是离线签署？</span>
                            <br>
                            <div class="offline_answer">
                                离线签署即将证书文件和印模图片写入Ukey工具，签署时通过签名软件读取Ukey工具实现离线电子签名，即使没有网络同样可以正常签署。
                            </div>
                        </div>
                    </div>
                    <div class="offline_card">
                        <span>
                            1、申请电子印章，申请Ukey介质。
                        </span>
                        <div class="btn" @click="goToSeal">
                            申请印章
                        </div>
                        <div class="btn" @click="goToUkeyList">
                            申请Ukey
                        </div>
                    </div>
                    <div class="offline_card">
                        <span>
                            2、下载安装TrustSignPDF(支持windows)。
                        </span>
                        <div class="btn" @click="downloadTrustSignPDF">
                            立即下载
                        </div>
                    </div>
                    <div class="offline_card">
                        <span>
                            3、TrustSignPDF使用介绍。
                        </span>
                        <div class="btn" @click="downloadTrustSignPDFInstruction">
                            立即下载
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        data() {
            return {

            }
        },
        mounted() {

        },
        methods: {
            goToSeal() {
                this.$router.push({
                    path: '/sealList'
                });
            },
            goToUkeyList() {
                this.$router.push({
                    path: '/ukeyList'
                });
            },
            downloadTrustSignPDF(){
                let aTag = document.createElement('a')
                aTag.download = "TrustSignPDF_install.exe"
                aTag.href = this.$global.Local+'ukey/client/TrustSignPDF.Standard.exe'
                aTag.style.display = 'none'
                document.body.appendChild(aTag)
                aTag.click()
                aTag.remove()
            },
            downloadTrustSignPDFInstruction(){
                //实现pdf的直接下载，而不是先预览
                axios({
                    method: 'get',
                    url: this.$global.Local+'ukey/client/TrustSignPDF_Instruction.pdf',
                    responseType: 'blob'
                }).then(function (response) {
                    let aTag = document.createElement('a')
                    let blob = new Blob([response.data], {type: response.data.type})
                    let url = URL.createObjectURL(blob)
                    aTag.download = "TrustSignPDF阅读器用户使用手册"
                    aTag.href = url
                    aTag.style.display = 'none'
                    document.body.appendChild(aTag)
                    aTag.click()
                    aTag.remove()
                })
            },
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    .template {
        width: @a;
        height: auto;

        .tempRight {
            width: @a;
            height: auto;
            padding-left: 4%;

            .tempTitle {
                width: 1075px;
                height: 40px;
                display: @flex;
                align-items: center;
                justify-content: space-between;

                .left {
                    width: auto;
                    height: 24px;
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 24px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 1px;
                    color: #333333;
                }

                .right {
                    width: 370px;
                    height: 40px;
                    display: @flex;
                    justify-content: flex-end;

                    .btn {
                        width: 80px;
                        height: 40px;
                        background-color: #f5f5f5;
                        border: solid 1px #aaaaaa;
                        letter-spacing: 1px;
                        color: #333333;
                        font-size: 16px;
                        line-height: 40px;
                        text-align: center;
                        cursor: pointer;
                    }
                }
            }

            .temp_for {
                width: 1100px;
                height: auto;

                .offline {
                    color: #333333;
                    font-size: 18px;

                    .offline_card {
                        padding: 8px 16px;
                        border-radius: 4px;
                        background-color: #f5f5f5;
                        border-left: 5px solid #1e6eee;
                        margin: 20px 0;
                        min-height: 100px;
                        display: flex;
                        align-items: center;
                        line-height: 26px;

                        .offline_what{
                            font-weight: bold;
                        }

                        .offline_answer{
                            max-width: 800px;
                        }

                        .btn{
                            padding: 3px 15px;
                            margin-left: 10px;
                            background-image: linear-gradient(#1e6eee 0%, #109ee7 50%, #01cee0 100%);
                            border-radius: 15px;
                            font-size: 18px;
                            font-weight: 550;
                            cursor: pointer;
                            color: #fff;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/contract/offline_sin.vue